import { Component, HostListener, OnInit } from "@angular/core";
import { AppService } from "../services/app.service";
import { HttpService } from "../services/http.service";
import { Router } from "@angular/router";
import { AlertController } from "@ionic/angular";
import { NavController, MenuController } from "@ionic/angular";
import { Title } from "@angular/platform-browser";

@Component({
  selector: "app-support",
  templateUrl: "./support.page.html",
  styleUrls: ["./support.page.scss"],
})
export class SupportPage implements OnInit {
  flags: any;
  public isColumnVisible: boolean = true;

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.checkScreenSize();
  }

  constructor(
    public app: AppService,
    public http: HttpService,
    private router: Router,
    private navCtrl: NavController,
    private alertController: AlertController,
    public title: Title
  ) {
    this.checkScreenSize();
    this.flags = {
      badges: { open: 0, unassigned: 0, mine: 0 },

      search: null,
      searchStyle: 0,
      advancedSearch: {
        id: "",
        first_name: "",
        last_name: "",
        phone: "",
        uli: "",
      },
      searchFocus: 0,
      results: [],

      sessions: [],

      sitesList: [],

      filter: {
        main: null,
        source_type: null,
        site_id: null,
      },
    };
  }

  ionViewDidEnter() {
    //this.app.alert(this.app.sysData.permission);
    if (this.app.sysData.access == 2 || this.app.sysData.access == 3 || this.app.sysData.access == 9) {
      this.getSites();
      this.getData();
    } else {
      this.navCtrl.navigateRoot("/home");
    }
  }

  checkScreenSize() {
    this.isColumnVisible = window.innerWidth >= 768; // Example breakpoint for md screens
  }

  toggleColumn() {
    this.isColumnVisible = !this.isColumnVisible;
  }

  getSites() {
    this.http.apiGet("company_sites/company_id/" + this.app.sysData.company_id, null).then((data) => {
      console.log("get sites", data.data);

      var obj = data.data;
      for (var i in obj) {
        //iterate through and format for popup
        obj[i].label = obj[i].name;
        obj[i].type = "radio";
        obj[i].value = obj[i].id;
      }
      this.flags.sitesList = obj;
    });
  }

  searchTickets() {
    var badges = { open: 0, unassigned: 0, mine: 0 };
    console.log("search");
    var arr = [];

    if (!this.flags.search) {
      this.flags.search = "";
    }

    console.log("SYS DATA", this.app.sysData);

    var string = this.flags.search.split(" ");
    for (var q in string) {
      //iterate through query
      var regex = new RegExp(string[q], "i");
      for (var i in this.flags.sessions) {
        if (this.flags.sessions[i].status != "closed") {
          badges.open++;
        }
        if (!this.flags.sessions[i].user_id) {
          badges.unassigned++;
        }
        if (this.flags.sessions[i].user_id == this.app.sysData.userId) {
          badges.mine++;
        }

        if (
          (this.flags.sessions[i].name && this.flags.sessions[i].name.search(regex) != -1) ||
          (this.flags.sessions[i].id && this.flags.sessions[i].id.toString().search(regex) != -1) ||
          (this.flags.sessions[i].ref && this.flags.sessions[i].ref.search(regex) != -1)
        ) {
          var fiterFlag = true;

          //if searching for unassigned tickets and ticket is assigned remove it
          if (fiterFlag && this.flags.filter.main == 2 && this.flags.sessions[i].user_id) {
            fiterFlag = false;
          }

          //if searching for my ticktes and ticket is assigned to someone else remove it
          if (fiterFlag && this.flags.filter.main == 1 && this.flags.sessions[i].user_id != this.app.sysData.userId) {
            fiterFlag = false;
          }

          //location filter if its not the location i want remove it
          if (
            fiterFlag &&
            this.flags.filter.site_id != null &&
            this.flags.sessions[i].site_id != this.flags.filter.site_id
          ) {
            //filter by site_id
            fiterFlag = false;
          }

          //type filter if its not the type i want remove it
          if (
            fiterFlag &&
            this.flags.filter.source_type != null &&
            this.flags.sessions[i].source_type != this.flags.filter.source_type
          ) {
            //filter by source
            fiterFlag = false;
          }

          //if the flag is still true pass onto results
          if (fiterFlag) {
            arr.push(this.flags.sessions[i]);
          }
        }
      }
    }

    this.flags.badges = JSON.parse(JSON.stringify(badges));
    this.flags.results = JSON.parse(JSON.stringify(arr));

    console.log(this.flags.results);
  }

  getData() {
    //this.http.apiGet('sessions/company_id/' + this.app.sysData.company_id + '?join=user_accounts,user_id,id,email:first_name:last_name&orderby=id+desc', null).then(data => {
    this.http
      .apiGet(
        "sessions/company_id/" +
          this.app.sysData.company_id +
          "?join=user_accounts,user_id,id,email:first_name:last_name&orderby=id+desc",
        null
      )
      .then((data) => {
        //this.app.notification('tickets');
        // this.app.notify('Tickets Loaded', 'primary');
        console.log("get sites", data.data);
        this.flags.sessions = data.data;
        this.searchTickets();
      });
  }

  viewPage(m, id) {
    if (m == 1) {
      this.router.navigateByUrl("/support-session/0");
    }

    if (m == 1.1) {
      this.router.navigateByUrl("/support-session/" + id);
    }
  }

  createSession(id) {
    if (id) {
      this.app.load("Connecting", 1000);
      var obj = {
        token: "a",
        site_id: id,
        source_type: "agent",
      };

      this.http.post("https://xmiiwtx0ab.execute-api.us-west-2.amazonaws.com/default/activate/a", obj).then((data) => {
        console.log(data);
        var id = data["data"].insertId;

        if (id) {
          this.app.stopload();
          this.router.navigateByUrl("/support-session/" + id);

          //this.flags.sessionID = data['data'].insertId;
          //this.subscribe();
        } else {
          this.app.alert("Error occured please try again");
        }
      });
    }
  }

  createTwilioConversation(id) {
    var identity = "Support"; //                this.app.sysData.agent_name = data.data[0].name;
    var room = id;
    var sid = null; //obj.conversation_sid

    this.http
      .get(
        "https://xmiiwtx0ab.execute-api.us-west-2.amazonaws.com/default/twilio/token/?identity=" +
          identity +
          "&room=" +
          room +
          "&sid=" +
          sid
      )
      .then((data) => {
        this.app.stopload();
        this.router.navigateByUrl("/support-session/" + id);

        console.log(data);
      })
      .catch((err) => {
        this.app.stopload();
        this.app.alert("Communication error occured please try again");
      });
  }

  ngOnInit() {
    this.title.setTitle("Support Session Management");
    this.getData();
    //LISTEN FOR CHANGING DATA
    this.app.event$.subscribe((data) => {
      // Do something with the data here
      // this.app.notify('New Ticket In Que', 'primary');

      if (data.length > this.flags.sessions.length) {
        this.app.playSound();
        this.app.notify("New Ticket", "tertiary");
      }

      this.flags.sessions = JSON.parse(JSON.stringify(data));
      this.searchTickets();
      console.log(data);
    });
  }

  ionViewWillLeave() {
    //this.unsubscribe();
    //this.app.unsubscribe();
  }

  async presentAlert() {
    const alert = await this.alertController.create({
      header: "Select location / Sélectionnez l'emplacement",
      //mode: 'ios',
      buttons: [
        {
          text: "Cancel",
          role: "cancel",
          cssClass: "secondary",
          handler: (blah) => {
            console.log("Confirm Cancel: blah");
          },
        },
        {
          text: "Okay",
          handler: (e) => {
            console.log("Confirmed", e);
            this.createSession(e);
          },
        },
      ],
      inputs: this.flags.sitesList,
    });

    await alert.present();
  }
}
